// extracted by mini-css-extract-plugin
export default {"spinner":"spinner-component_spinner__CWveF","spin":"spinner-component_spin__DrvI5","viewPortOverlay":"spinner-component_viewPortOverlay__bX6tZ"};